import React from 'react';
import { arrayOf, func, shape, string, bool } from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';

import { operations } from 'state/ducks/routeCreation';

import InlineButton from 'components/InlineButton';

import CloseIcon from 'icons/close.inline.svg';
import SegmentSmallIcon from 'icons/segment-small.inline.svg';
import SegmentSmallBrokenIcon from 'icons/segment-small-broken.inline.svg';

import styles from './Header.scss';

function createRouteItem(
  segment,
  showRemoveButton,
  onClickHandler,
  hasOneSegment,
  index,
  isFinished
) {
  const isReporting = segment.status !== 'disconnected';
  return (
    <li key={`Via-${segment.id}`}>
      <div className={styles.item}>
        <span className={styles.segmentNumber}>
          {index + 1}
        </span>
        <div className={styles.label}>
          {isReporting
            ? <SegmentSmallIcon width={8} className={styles.icon} />
            : <SegmentSmallBrokenIcon width={8} className={styles.icon} />}

          <div className={styles.labelContent}>
            <span>
              {segment.from.name}
            </span>
            <span>
              {segment.to.name}
            </span>
          </div>
        </div>
        {!isFinished &&
          <InlineButton showLabel={false} onClick={() => onClickHandler(segment.id)}>
            <CloseIcon />
          </InlineButton>}
      </div>
      {hasOneSegment &&
        <div className={cx(styles.label, styles.emptyListSegment)}>
          <div className={styles.labelContent}>
            <span className={styles.hint}>Select a second segment</span>
          </div>
        </div>}
    </li>
  );
}

function Header({ selectedSegments, deselectSegment, isFinished }) {
  const hasMoreSegments = selectedSegments.length === 1;

  if (selectedSegments.length === 0) return null;

  return (
    <ul className={styles.main}>
      {selectedSegments.map((segment, index) =>
        createRouteItem(segment, false, deselectSegment, hasMoreSegments, index, isFinished)
      )}
    </ul>
  );
}

Header.propTypes = {
  selectedSegments: arrayOf(
    shape({
      id: string,
      from: shape({
        id: string,
        name: string,
      }),
      to: shape({
        id: string,
        name: string,
      }),
    })
  ).isRequired,
  deselectSegment: func.isRequired,
  isFinished: bool.isRequired,
};

const ConnectedHeader = connect(null, operations)(Header);

export default ConnectedHeader;



// WEBPACK FOOTER //
// ./src/components/MapPanel/CreateRoute/Header/index.js